import { Layout, Button, Modal, Progress, Input, message } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideNavBar from "../../Components/SideBar/Sidebar";
import "../Dashboard/Dashboard.css";
import UserDashboard from "../../Components/UserTasks/UserDashboard";
import PieChart from "../../Components/PieChart/PieChart";
import MarqueeHeader from "../../Components/Marquee/Marquee";
import { StringValidations } from "../../Utils/Utils";
import {
  PlusCircleOutlined,
  CaretLeftOutlined,
  CaretRightOutlined,
} from "@ant-design/icons";
import Navbar from "../../Components/Support/Header";
import Cookies from "js-cookie";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { Redirect } from "react-router-dom";
import {
  loadUpdates,
  addUpdate,
  callNotifications,
  getTotalGroupPercentage
} from "../../redux/DashboardRedux/DashboardActions";

const { Header, Content } = Layout;
const { TextArea } = Input;
const Dashboard = () => {
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [content, setContent] = useState("");
  var currentdate = new Date();

  const payrollUpdates = useSelector((state) => state.dashboardreducer.updates);
  const jwtToken = Cookies.get("jwt_token");
  const userLogin = Cookies.get("UserLogin");
  const firstName = Cookies.get("first_name");
  const lastName = Cookies.get("last_name");
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [errorMSG, showErrorMSG] = useState(false);
  const [groupPer, setGroupPer] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [displayCycle, setDisplayCycle] = useState(1);
  const [doughnutData, setDoughtnutData] = useState([])

  var Call = 0;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadUpdates());
    if (Call === 0) {
      Call = 1;
      callTaskStatusPercentage();
      dispatch(getTotalGroupPercentage());
    }
  }, []);

  const PerData = useSelector(
    (state) => state.dashboardreducer.percentages
  )

  const Groups = [
    "New Hire/ Re-Hires",
    "Payroll Timecards",
    "Payroll Masterfile",
    "Payroll Adjustment",
    "Payroll Export/ .CSV",
    "Payroll Audit/ Review",
    "Health Insurance",
    "Garnishments",
    "Contigent Expenses",
    "Corporate Expenses",
    "Off-Cycle Payroll",
    "Reporting",
  ];

  const callTaskStatusPercentage = async () => {
    setGroupPer([]);
    groupPer.length = 0;
    setDoughtnutData([])
    doughnutData.length = 0;
    let i = 0;
    for (i = 0; i < Groups.length; i++) {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}UserTask/GetPercentage?groupname=` +
        Groups[i],
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      groupPer.push(res.data);
      setGroupPer([...groupPer], res.data);
      doughnutData.push({
        'gName': Groups[i],
        'percent': res.data[0]
      })
    }
    setDoughtnutData([...doughnutData])
  };

  const openAddUpdatePopup = () => {
    setShowAddPopup(true);
  };
  function ParseToText(text) {
    let result = new DOMParser().parseFromString(text, 'text/html');
    return result.body.textContent;
  }

  const sendForApproval = async () => {
    let markupToTextContent = content.replace(/<\/?p>/g, "");
    markupToTextContent = markupToTextContent.replace(/&nbsp;/g, ' ');
    if (markupToTextContent.trim() !== "" && StringValidations(ParseToText(markupToTextContent))) {
      try {


        // Convert URLs to clickable links
        markupToTextContent = markupToTextContent.replace(
          /(https?:\/\/\S+|www\.\S+)/g,
          '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
        );
        setApprovalLoading(true);

        const response = await dispatch(addUpdate(markupToTextContent, currentdate));

        setApprovalLoading(false);
        setContent("");
        setShowAddPopup(false);

        if (response.data !== "payroll update is posted successfully") {
          setTimeout(() => {
            failure();
          }, 1000);
        } else {
          dispatch(callNotifications());
        }
      } catch (error) {
        console.error("Error sending for approval:", error);
        setApprovalLoading(false);
      }
    } else {
      showErrorMSG(true);
    }
  };

  const failure = () => {
    messageApi.open({
      type: "error",
      content: "Cannot add update",
    });
  };
  const closeAddUpdatePopup = () => {
    setShowAddPopup(false);
    showErrorMSG(false);
    setContent("");
  };
  const renderContent = (item, index) => {
    if (typeof item !== "string") {
      return <div key={index}>{item}</div>;
    }

    const regex =
      /(\b(?:https?:\/\/\S+|www\.\S+|\S+)\b|\s+|[|@#$%^&*+=><~.,!?:;"'()[\]{}-])/g;
    const parts = item.match(regex) || [];
    const isHtml = (str) => {
      const doc = new DOMParser().parseFromString(str, "text/html");
      return Array.from(doc.body.childNodes).some(
        (node) => node.nodeType === 1
      );
    };

    if (isHtml(item)) {
      return <div dangerouslySetInnerHTML={{ __html: item }} />;
    }

    return (
      <React.Fragment key={index}>

        {parts.map((part, i) => {
          if (/^(https?:\/\/|www\.)\S+$/i.test(part)) {
            // If it's a URL, render it as a clickable link
            return (
              <a
                key={i}
                href={part}
                style={{ wordWrap: "break-word", borderBottom: "1px solid", color: "inherit" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {part}
              </a>
            );
          } else {
            // Check if the part contains color styling
            const colorMatch = /color:\s*rgb\((\d+),\s*(\d+),\s*(\d+)\);?/i.exec(part);
            if (colorMatch) {
              const colorStyle = colorMatch[0];
              const text = part.replace(colorMatch[0], '');

              return (
                <span
                  key={i}
                  style={{
                    wordWrap: "break-word",
                    borderBottom: "1px solid",
                    ...parseColorStyle(colorStyle),
                  }}
                >
                  {text}
                </span>
              );
            } else {
              return <span key={i}>{part}</span>;
            }
          }
        })}
        <br />
      </React.Fragment>
    );
  };

  // Function to parse color style and convert it to an object
  const parseColorStyle = (colorStyle) => {
    const match = /color:\s*rgb\((\d+),\s*(\d+),\s*(\d+)\);?/i.exec(colorStyle);
    if (match) {
      const [, r, g, b] = match.map(Number);
      return { color: `rgb(${r},${g},${b})` };
    }
    return {};
  };
  if (jwtToken === undefined) {
    return <Redirect to="/" />;
  }
  const toolbarOptions = {
    toolbar: [["bold", "italic", "underline"], [{ color: [] }]],
  };

  const formats = ["bold", "italic", "underline", "color"];

  return (
    <div>
      <Layout
        style={{
          backgroundColor: "white",
          height: "100vh",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <SideNavBar />
        <Layout className="whole-div">
          <Header className="whole-header-class">
            <MarqueeHeader />
            <Navbar />
          </Header>
          <Content className="dashboard-content">
            <div className="chart-cards-row">
              <div className="chart-row">
                <PieChart doughnutData={doughnutData} displayCycle={displayCycle} />
              </div>
              <div className="cards-row">
                {displayCycle === 1 ? (
                  <div className="cards-inside-row">
                    <div className="cycle-change-arrow">
                      <CaretLeftOutlined
                        style={{
                          fontSize: 18.58,
                          color: "rgba(217, 217, 217, 1)",
                        }}
                      />
                      <span className="cycle-heading">
                        &nbsp;Regular Payroll&nbsp;&nbsp;
                      </span>
                      <CaretRightOutlined
                        style={{ fontSize: 18.58, cursor: "pointer" }}
                        onClick={() => setDisplayCycle(2)}
                      />
                    </div>
                    <div className="cards-second-row">
                      <div className="inside-cards">
                        <Progress
                          type="circle"
                          percent={PerData[0] ? parseFloat(PerData[0]).toFixed(0) : 0}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>New hires/ Rehires</div>
                      </div>
                      <div className="inside-cards">
                        <Progress
                          type="circle"
                          percent={PerData[6] ? parseFloat(PerData[6]).toFixed(0) : 0}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>Health Insurance</div>
                      </div>
                      <div className="inside-cards">
                        <Progress
                          type="circle"
                          percent={PerData[7] ? parseFloat(PerData[7]).toFixed(0) : 0}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>Garnishments</div>
                      </div>
                      <div className="inside-cards">
                        <Progress
                          type="circle"
                          percent={PerData[1] ? parseFloat(PerData[1]).toFixed(0) : 0}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>Timecards</div>
                      </div>
                    </div>
                    <div className="cards-first-row">
                      <div className="inside-cards">
                        <Progress
                          type="circle"
                          percent={PerData[2] ? parseFloat(PerData[2]).toFixed(0) : 0}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>Payroll Masterfile</div>
                      </div>
                      <div className="inside-cards">
                        <Progress
                          type="circle"
                          percent={PerData[3] ? parseFloat(PerData[3]).toFixed(0) : 0}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>Payroll Adjustments</div>
                      </div>
                      <div className="inside-cards">
                        <Progress
                          type="circle"
                          percent={PerData[5] ? parseFloat(PerData[5]).toFixed(0) : 0}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>Payroll audit review</div>
                      </div>
                      <div className="inside-cards">
                        <Progress
                          type="circle"
                          percent={PerData[4] ? parseFloat(PerData[4]).toFixed(0) : 0}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>Payroll Export/ .CSV</div>
                      </div>
                    </div>
                  </div>
                ) : displayCycle === 2 ? (
                  <div className="cards-inside-row">
                    <div className="cycle-change-arrow">
                      <CaretLeftOutlined
                        style={{ fontSize: 18.58, cursor: "pointer" }}
                        onClick={() => setDisplayCycle(1)}
                      />
                      <span className="cycle-heading">
                        &nbsp;Off Cycle Payroll&nbsp;&nbsp;
                      </span>
                      <CaretRightOutlined
                        style={{ fontSize: 18.58, cursor: "pointer" }}
                        onClick={() => setDisplayCycle(3)}
                      />
                    </div>
                    <div className="cards-new-row">
                      <div className="inside-cards">
                        <Progress
                          type="circle"
                          percent={30}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>Late Submission</div>
                      </div>
                      <div className="inside-cards">
                        <Progress
                          type="circle"
                          percent={20}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>Commisions</div>
                      </div>
                      <div className="inside-cards">
                        <Progress
                          type="circle"
                          percent={10}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>Bonuses</div>
                      </div>
                      <div className="inside-cards">
                        <Progress
                          type="circle"
                          percent={65}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>Exception Pay</div>
                      </div>
                    </div>
                    {/* <div className="cards-first-row"> */}

                    {/* <div className="inside-cards">
                    <Progress type="circle" percent={90} size={35}
                      strokeColor={'rgba(0, 80, 179, 0.4)'}
                      trailColor="#e0e4eb"
                      className="progress-circle" />
                    <div>----------</div>
                  </div>
                  <div className="inside-cards">
                    <Progress type="circle" percent={90} size={35}
                      strokeColor={'rgba(0, 80, 179, 0.4)'}
                      trailColor="#e0e4eb"
                      className="progress-circle" />
                    <div>----------</div>
                  </div> */}
                    {/* </div> */}
                  </div>
                ) : (
                  <div className="cards-inside-row">
                    <div className="cycle-change-arrow">
                      <CaretLeftOutlined
                        style={{ fontSize: 18.58, cursor: "pointer" }}
                        onClick={() => setDisplayCycle(2)}
                      />
                      <span className="cycle-heading">
                        &nbsp;Expenses Management&nbsp;&nbsp;
                      </span>
                      <CaretRightOutlined
                        style={{
                          fontSize: 18.58,
                          color: "rgba(217, 217, 217, 1)",
                        }}
                      />
                    </div>
                    <div className="expenses-cards-row">
                      <div className="expense-inside-cards">
                        <Progress
                          type="circle"
                          percent={PerData[8] ? parseFloat(PerData[8]).toFixed(0) : 0}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>Contingent Expenses</div>
                      </div>
                      <div className="expense-inside-cards">
                        <Progress
                          type="circle"
                          percent={PerData[9] ? parseFloat(PerData[9]).toFixed(0) : 0}
                          size={35}
                          strokeColor={"rgba(0, 80, 179, 0.4)"}
                          trailColor="#e0e4eb"
                          className="progress-circle"
                        />
                        <div>Corporate Expenses</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="calender-updates">
              <div className="userdashboard">
                <UserDashboard />
              </div>
              <div className="updates-displaying">
                <div className="payrollupdates-class">
                  <div className="heading-wholediv">
                    <div className="payroll-heading">
                      Payroll Updates
                      <span
                        onClick={openAddUpdatePopup}
                        style={{ cursor: "pointer" }}
                        className="plus-icon-class"
                      >
                        <PlusCircleOutlined />
                      </span>
                      {contextHolder}
                      <Modal
                        open={showAddPopup}
                        className="modalStyle"
                        style={{
                          marginLeft: "71%",
                          marginTop: "8%",
                          maxWidth: "25%",
                        }}
                        footer={false}
                        onOk={openAddUpdatePopup}
                        onCancel={closeAddUpdatePopup}
                      >
                        <div className="footer-textarea">
                          <ReactQuill
                            value={content}
                            onChange={(value) => {
                              setContent(value);
                              showErrorMSG(false);
                            }}
                            placeholder="Enter the text here"
                            theme="snow"
                            modules={toolbarOptions}
                            formats={formats}
                          />
                          <div className="approval-class">
                            <Button
                              className="approval-button"
                              loading={approvalLoading}
                              onClick={sendForApproval}
                            >
                              Send for approval
                            </Button>
                          </div>
                          {errorMSG && (
                            <div className="errormsg-class">
                              *Please enter text
                            </div>
                          )}
                        </div>
                      </Modal>
                    </div>
                  </div>
                  <div className="all-updates">
                    {payrollUpdates ? (
                      payrollUpdates.map((item, index) => {
                        return (
                          <div className="render-update">
                            <li className="bullet-list"></li>
                            <p className="paragraph-class" key={index}>
                              {renderContent(item.Description, index)}
                            </p>
                          </div>
                        );
                      })
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};
export default Dashboard;
